import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Back from "shared/assets/images/svg/back_blue.svg";
import Input from "shared/component/inputFields";
import { useProfile } from "customer/settings/myProfile/profile.service";
import FileUploader from "shared/component/file-upload/file-uploader";

const MyProfile = () => {
  const{t}=useTranslation();
  const {
    register,
    profileData,
    formState: { errors },
    watch,
    handleSubmit,
    control,
    setValue
  } = useProfile();

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        handleSubmit();
      }}
      className="settingHome myProfile"
    >
      <div className="container">
        <div className="header">
          <div className="page-name">
            <Link className="linkBack" to="/settings">
              <img src={Back} alt="back" />
            </Link>
            <h1>{t('my-profile.profile')}</h1>
          </div>
          <div className="info">
            {/* <p>348Bb1e3-9Fc3-Eb11-Aaf7-A08cfdc10c21</p> */}
          </div>
        </div>
        <hr className="hr" />
        <div className="row">
          <div className="col-md-6">
      
              <div className="form-group form-div mt-0 row g-3 align-items-center">
                <label className="col-lg-4 col-form-label ">
                {t('my-profile.number')}
                </label>
                <div className="col-lg-8">
                  <Input
                    type="text"
                    {...register("customerNumber")}
                    readonly
                  />
                </div>
              </div>

              <div className="form-group form-div mt-0 row g-3 align-items-center">
                <label className="col-lg-4 col-form-label ">
                {t('my-profile.company-name')}
                </label>
                <div className="col-lg-8">
                  <Input type="text"  {...register("username")} readonly />
                </div>
              </div>

              <div className="form-group form-div mt-0 row g-3 align-items-center">
                <label className="col-lg-4 col-form-label ">
                {t('my-profile.name')} <small className="star-require">*</small>
                </label>
                <div className="col-lg-8">
                <Input
              type="text"
              require
              {...register("customerName")}
              error={errors.customerName?.message}
            />
                </div>
              </div>

              <div className="form-group form-div mt-0 row g-3 align-items-center">
                <label className="col-lg-4 col-form-label ">
                {t('my-profile.job')}
                </label>
                <div className="col-lg-8">
                <Input
              type="text"
              require
              {...register("customerPosition")}
              value={watch("customerPosition")}
              error={errors.customerPosition?.message}
            />
                </div>
              </div>

          </div>
          <div className="col-md-6">
            <div className="col-lg-6 ">
              <span className="imgTitle">{t('my-profile.image')}</span>
               <FileUploader
                  label={t('my-profile.click-here')}
                  name="photo"
                  onFileSubmit={(file) => setValue("photo", file)}
                  binaryImg='true'
                  initialImage={profileData?.photo}
                />
            </div>

          </div>
          <hr className="hr hr-margin" />
          <div className="col-12">
            <div className="row">
              <div className="col-md-6">
              <div className="form-group form-div mt-0 row g-3 align-items-center">
                <label className="col-lg-4 col-form-label ">
                {t('my-profile.phone')}
                </label>
                <div className="col-lg-8">
                <Input
                  type="phone"
                  control={control}
                  name="customerPhone"
                  error={errors.customerPhone?.message}
                />
                </div>
              </div>
              <div className="form-group form-div mt-0 row g-3 align-items-center">
                <label className="col-lg-4 col-form-label ">
                {t('my-profile.alt-phone')}
                </label>
                <div className="col-lg-8">
                <Input
                  type="phone"
                  control={control}
                  name="alternativePhone"
                  error={errors.alternativePhone?.message}
                />
                </div>
              </div>
              </div>

              <div className="col-md-6">
              <div className="form-group form-div mt-0 row g-3 align-items-center">
                <label className="col-lg-4 col-form-label ">
                {t('my-profile.mail')}
                </label>
                <div className="col-lg-8">
                <Input
                  type="text"
                  error={errors.email?.message}
                  value={watch("email")}
                  {...register("email")}
                />
                </div>
              </div>

              <div className="form-group form-div mt-0 row g-3 align-items-center">
                <label className="col-lg-4 col-form-label ">
                {t('my-profile.id')}
                </label>
                <div className="col-lg-8">
                <Input
                  type="text"
                  {...register("personalId")}
                  error={errors.personalId?.message}
                />
                </div>
              </div>


              </div>

            </div>
          </div>
        </div>
      </div>
      {/* <div className="action">
        <div className="container">
          <button className="btn-blue" type="submit" disabled={isLoading}>
            <Spinner animation="border" size="sm" hidden={!isLoading} />
            Save Changes
          </button>
        </div>
      </div> */}
    </form>
  );
};

export default MyProfile;
